export default {
    methods: {
        async invokeOpenHelpMenu() {
            if (!this.$isMobileDevice()) { return }

            window.console.log("try invokeCSharpChangeInstance");

            try {
                // eslint-disable-next-line no-undef
                return invokeCSharpOpenHelpMenu(); // RENAME OR REMOVING WILL BREAK MOBILEWRAPPER
            } catch (e) {
                window.console.error(e)
            }
        },
    },
}
